module.exports = __webpack_public_path__ + "img/NL563.4a72bbfa.png";